import type { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import Icon from '../icon'

interface TermsCheckboxProps {
  isChecked: boolean
  setIsChecked: Dispatch<SetStateAction<boolean>>
  onClick: () => void
}

const TermsCheckbox = ({
  isChecked,
  setIsChecked,
  onClick,
}: TermsCheckboxProps) => {
  const { t } = useTranslation('walletManagement')

  return (
    <div className="flx-ctr mb-5 items-start">
      <button
        className="flx-ctr w-5 h-5 min-w-5 rounded-full border border-txt"
        onClick={() => setIsChecked(prev => (prev ? false : true))}>
        {isChecked && <Icon id="check" width={20} height={20} className="stroke-txt"/>}
      </button>
      <p className="text-sm lg:text-base text-txt ml-2">
        {t('read-the-terms')} <button onClick={onClick} className="text-sm lg:text-base text-txt underline">{t('terms')}</button>{' '}
        {t('this-promo')}
      </p>
    </div>
  )
}

export default TermsCheckbox
